import React from 'react';
import { createUseStyles } from 'react-jss';
import fontWeights from '../../../tokens/fontWeights';
import colours from '../../../tokens/colours';
import baseStyles from '../../../atoms/styles/baseStyles';
import ellipsisStyles from '../../../atoms/styles/ellipsisStyles';
import fonts from '../../../tokens/fonts';
export const OPTION_HEIGHT = 52;
const getStyles = createUseStyles({
    ...baseStyles,
    root: {
        ...ellipsisStyles,
        display: 'block',
        fontFamily: fonts.roboto,
        fontWeight: fontWeights.Regular,
        padding: [16, 16, 0, 16],
        height: OPTION_HEIGHT,
        fontSize: '1.4rem',
        lineHeight: '2rem',
        color: colours.primary,
        cursor: 'pointer',
        borderRadius: 4,
        backgroundColor: 'transparent',
        transition: ['background-color', '0.2s', 'linear'],
        '&:hover': {
            backgroundColor: colours.quarternary,
        }
    }
});
const MenuOption = ({ children, value, checked = false, onClick }) => {
    const styles = getStyles();
    return (React.createElement("label", { className: styles.root },
        React.createElement("input", { key: value, type: "radio", value: value, checked: checked, onClick: onClick }),
        children));
};
export default MenuOption;
//# sourceMappingURL=MenuOption.js.map